import DisciplineDetail from "@/pages/DisciplineDetail";

export default function BJJ() {
  return <DisciplineDetail slug="bjj" orariId="bjj-grappling" />;
}
